/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Box } from "@mui/material";

type ProvenExpertSealStandardProps = {
  align?: "left" | "right" | "center";
  marginTop?: string | number;
  maxWidth?: string | number;
};

const ProvenExpertSealStandard = ({ align = "center", marginTop = "1.25rem", maxWidth = "100%" }: ProvenExpertSealStandardProps) => {
  return (
    <Box sx={{ textAlign: align }}>
      <a
        href="https://www.provenexpert.com/legalbird/?utm_source=Widget&amp;utm_medium=Widget&amp;utm_campaign=Widget"
        title="Erfahrungen &amp; Bewertungen zu Legalbird anzeigen"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Box
          component={"img"}
          src="https://images.provenexpert.com/ca/70/17a7e460654ab3270025208dddab/widget_square_200_de_0.png"
          alt="Erfahrungen &amp; Bewertungen zu Legalbird"
          sx={{ maxWidth: maxWidth, border: 0, marginTop: marginTop }}
        />
      </a>
    </Box>
  );
};

export default ProvenExpertSealStandard;
